import Blue from "~/core";

new Blue({
	name: 'Newspaper',
	selector: ".newspaper",
	setup(newspaper) {
		const hero = newspaper.querySelector('.newspaper-hero');
		const main = newspaper.querySelector('.newspaper-main');

		this.$addEvents(hero, 'mousewheel', e => {
			const positive = e.deltaY > 0;
			if (main.scrollTop <= 0 && !positive) return;
			if (main.scrollTop >= main.scrollHeight - main.offsetHeight && positive) return;
			main.scrollTop = main.scrollTop + e.deltaY;
		});
	}
});
